// extracted by mini-css-extract-plugin
export var columnItem = "_b4-3";
export var columnItemDraggable = "_b4-4";
export var dragHandle = "_b4-0";
export var dragHandleHovered = "_b4-1";
export var dropdown = "_b4-5";
export var dropdownContent = "_b4-7";
export var dropdownInner = "_b4-6";
export var filterDropdownHeader = "_b4-8";
export var icon = "_b4-2";
export var sectionDivider = "_b4-9";